import { render, staticRenderFns } from "./templates.table.vue?vue&type=template&id=fa58064c&scoped=true&"
import script from "./templates.table.vue?vue&type=script&lang=js&"
export * from "./templates.table.vue?vue&type=script&lang=js&"
import style0 from "./templates.table.vue?vue&type=style&index=0&id=fa58064c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa58064c",
  null
  
)

export default component.exports